import { lazy, Suspense, type ReactElement } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/router/ProtectedRoute';
import { RoleRoute } from '@/router/RoleRoute';
import { RouteFallback } from '@/components/shared/RouteFallback';

// BUG-001 (BUGS.md) — route-based code splitting: har bir sahifa alohida chunk.
const HomePage = lazy(() => import('./pages/HomePage').then((m) => ({ default: m.HomePage })));
const DeliverPage = lazy(() => import('./pages/DeliverPage').then((m) => ({ default: m.DeliverPage })));
const OrdersPage = lazy(() => import('./pages/OrdersPage').then((m) => ({ default: m.OrdersPage })));
const DebtsPage = lazy(() => import('./pages/DebtsPage').then((m) => ({ default: m.DebtsPage })));
const CashPage = lazy(() => import('./pages/CashPage').then((m) => ({ default: m.CashPage })));
const ReconciliationPage = lazy(() =>
  import('./pages/ReconciliationPage').then((m) => ({ default: m.ReconciliationPage })),
);
const StatsPage = lazy(() => import('./pages/StatsPage').then((m) => ({ default: m.StatsPage })));
const ActivityPage = lazy(() => import('./pages/ActivityPage').then((m) => ({ default: m.ActivityPage })));
const ProfilePage = lazy(() => import('./pages/ProfilePage').then((m) => ({ default: m.ProfilePage })));
const NotificationsPage = lazy(() =>
  import('./pages/NotificationsPage').then((m) => ({ default: m.NotificationsPage })),
);

function courier(element: ReactElement): ReactElement {
  return (
    <ProtectedRoute>
      <RoleRoute roles={['COURIER', 'ADMIN', 'MANAGER']}>
        <Suspense fallback={<RouteFallback />}>{element}</Suspense>
      </RoleRoute>
    </ProtectedRoute>
  );
}

/**
 * F3 — Dostavshik ekranlari (C-01…C-07) va offline yetkazish.
 * CLAUDE.md §6 — registry.ts tomonidan avtomatik yig'iladi.
 * Yo'llar `lib/navConfig.ts` dagi NAV_CONFIG.COURIER bilan mos.
 */
export const routes: RouteObject[] = [
  { path: '/courier', element: courier(<HomePage />) },
  { path: '/courier/orders', element: courier(<OrdersPage />) },
  { path: '/courier/deliver', element: courier(<DeliverPage />) },
  { path: '/courier/deliver/:orderId', element: courier(<DeliverPage />) },
  { path: '/courier/debts', element: courier(<DebtsPage />) },
  { path: '/courier/cash', element: courier(<CashPage />) },
  { path: '/courier/reconciliation', element: courier(<ReconciliationPage />) },
  { path: '/courier/stats', element: courier(<StatsPage />) },
  { path: '/courier/activity', element: courier(<ActivityPage />) },
  { path: '/courier/profile', element: courier(<ProfilePage />) },
  { path: '/courier/notifications', element: courier(<NotificationsPage />) },
];
